import { useTranslation } from "react-i18next";
import { AnecdoteStatus } from "../types/models";
import { getStatusColor } from "../utils/anecdoteUtils";

type AnecdoteStatusBadgeProps = {
  status: AnecdoteStatus;
  className?: string;
};

export const AnecdoteStatusBadge = ({
  status,
  className = "",
}: AnecdoteStatusBadgeProps) => {
  const { t } = useTranslation();
  const { bg, text } = getStatusColor(status);

  return (
    <span
      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-opacity-40 ${bg} ${text} ${className}`}
    >
      {t(`anecdotes.status.${status}`)}
    </span>
  );
};
